import React from 'react';

const NotificationPip = ({ count }) => {
  if (!count || count === 0) {
    return null; 
  }
  
  return (
    <span style={{
      backgroundColor: '#dc3545', 
      color: 'white',
      fontSize: '10px',
      fontWeight: 'bold',
      padding: '2px 6px',
      borderRadius: '10px',
      minWidth: '20px',
      textAlign: 'center',
    }}>
      {count}
    </span>
  );
};

export default NotificationPip;